/**
 * @generated SignedSource<<aa913bf761ce543b6c8ae4e64b015953>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetFileUpdateInput = {
  setFiles?: ReadonlyArray<FileInput> | null;
  setSlideshowDuration?: number | null;
};
export type FileInput = {
  fileId: string;
  pageNumbers?: ReadonlyArray<number> | null;
};
export type WSFileUpdateMutation$variables = {
  update: WidgetFileUpdateInput;
  widgetId: string;
};
export type WSFileUpdateMutation$data = {
  readonly updateWidgetFile: {
    readonly id: string;
  };
};
export type WSFileUpdateMutation = {
  response: WSFileUpdateMutation$data;
  variables: WSFileUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "update"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "widgetId"
      },
      {
        "kind": "Variable",
        "name": "update",
        "variableName": "update"
      }
    ],
    "concreteType": "WidgetFile",
    "kind": "LinkedField",
    "name": "updateWidgetFile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WSFileUpdateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WSFileUpdateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5d567dd1c7060a5ec48b0662d3465fed",
    "id": null,
    "metadata": {},
    "name": "WSFileUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation WSFileUpdateMutation(\n  $widgetId: ID!\n  $update: WidgetFileUpdateInput!\n) {\n  updateWidgetFile(id: $widgetId, update: $update) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "eea527a1ddc41d260597d04d18261883";

export default node;
